import { Injectable } from '@angular/core';
import { NgxSpinnerService } from "ngx-spinner";
import { Observable, Subject } from "rxjs";
import { asyncScheduler } from 'rxjs';
import { observeOn } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class LoaderService {

  constructor(private spinner: NgxSpinnerService) { }
  isLoading = new Subject<boolean>();
  show() {
    this.isLoading.next(true);
    this.spinner.show();
  }
  hide() {
    this.isLoading.next(false);
    this.spinner.hide();
  }
  // getIsLoading$(): Observable<boolean> {
  //   return this.isLoading.asObservable()
  //   .pipe(observeOn(asyncScheduler));
  // }
  
}
